export enum EOptionsCalculatorParameters {
  S='S',
  K='K',
  v='v',
  T='T',
  r='r',
  q='q',
}
